export const requisites = [
    {
        label: 'Карта',
        value: 'card',
    },
    {
        label: 'СБП',
        value: 'sbp',
    },
] as const;
